<template>
    <div class="position-relative" v-click-outside="close">
        <a href="#" class="btn btn-link dropdown-toggle" @click.prevent="show = !show" >
            <span class="d-none d-lg-inline">Hello {{ $store.getters['auth/firstName'] }}</span>
            <img src="../../assets/images/person.svg" class="profile-image border p-2 rounded-circle ml-2" :alt="$store.getters['auth/firstName']">
        </a>
        <slide-y-up-transition>
            <div class="dropdown-menu dropdown-menu-right shadow show position-absolute" v-if="show">
                <a href="#" class="dropdown-item d-inline-block d-lg-none" @click.prevent="$router.push({name: 'Dashboard'}); close()">Home</a>
                <a href="#" class="dropdown-item d-inline-block d-lg-none" @click.prevent="$router.push({name: 'ProfileRewards'}); close()">
                    My Rewards: <span class="text-success font-weight-bold">£{{$store.getters['auth/balance'] || 0}}</span>
                </a>
                <a href="#" class="dropdown-item" @click.prevent="$router.push({name: 'ProfileSettings'}); close()">Settings</a>
                <a href="#" class="dropdown-item" @click.prevent="$router.push({name: 'Help'}); close()">Helpdesk</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="#" @click.prevent="signout">Sign out</a>
            </div>
        </slide-y-up-transition>
    </div>
</template>

<script>
import {SlideYUpTransition} from 'vue2-transitions'
import {EventBus, events} from '@/utils/event-bus';

export default {
        name: "ProfileDropDown",
        components: {SlideYUpTransition},
        data: function () {
            return {
                show: false
            }
        },
        methods: {
            open: function () {
                this.show = true;
            },
            close: function () {
                this.show = false;
            },
            signout: function () {
                this.$toast.success('Signed out successfully!')
                EventBus.$emit(events.auth.signout);
            }
        },
    }
</script>

<style scoped lang="scss">
    @import "../../sass/base";
    .dropdown-toggle {
        color: $gray-900;
        text-decoration: none;
        &:hover {
            text-decoration: none;
        }
        &:focus {
            text-decoration: none;
            box-shadow: none;
        }
        &::after {
            display: none;
        }
    }
    .profile-image {
        border-color: $gray-800 !important;
    }
</style>
